import { requireSupabase } from '../lib/supabase';

export async function redirectToLogin() {
  window.location.assign('/login');
}

let refreshInFlight = null;

async function renewSession() {
  if (!refreshInFlight) {
    refreshInFlight = requireSupabase().auth.refreshSession()
      .then(({ data, error }) => {
        if (error) throw error;
        return data.session;
      })
      .finally(() => { refreshInFlight = null; });
  }
  return refreshInFlight;
}

export async function acquireAuthSession({ rejectedToken, expectedUserId } = {}) {
  const { data, error } = await requireSupabase().auth.getSession();
  if (error) throw error;
  const session = data.session;
  if (!session?.access_token) return null;
  if (expectedUserId && session.user?.id !== expectedUserId) {
    throw new Error('La sesión ha cambiado. Vuelve a realizar la operación.');
  }
  const expiresSoon = Number.isFinite(session.expires_at) && session.expires_at * 1000 <= Date.now() + 30000;
  if (expiresSoon || (rejectedToken && rejectedToken === session.access_token)) {
    const refreshed = await renewSession();
    if (!refreshed) return null;
    const { data: current, error: currentError } = await requireSupabase().auth.getSession();
    if (currentError) throw currentError;
    if (!current.session) return null;
    if (current.session.user?.id !== session.user?.id || refreshed.user?.id !== session.user?.id) {
      throw new Error('La sesión ha cambiado. Vuelve a realizar la operación.');
    }
    return current.session;
  }
  return session;
}

export async function acquireAccessToken(options) {
  const session = await acquireAuthSession(options);
  return session?.access_token || null;
}

export async function getAccessToken() {
  return acquireAccessToken();
}
